import { AccountIbans } from '../../type';

export const extractIbanFromTrelFinNumFin = (numFin: AccountIbans['T_REL_FIN.NUM_FIN'] | null | undefined) => (numFin ? numFin.split(';')[1] : '');

export const getIbanFromAccountIban = (accountIban: AccountIbans | null | undefined) => (accountIban ? extractIbanFromTrelFinNumFin(accountIban['T_REL_FIN.NUM_FIN']) : '');
